var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXAirdrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 65 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.02225 61.6655L26.0234 35.0152L26.2941 34.7146L26.0566 34.3871L1.87928 1.0459H19.1922L35.5443 23.5422L35.9072 24.0415L36.3203 23.5828L56.6181 1.0459H60.6787L38.0009 26.2434L37.73 26.5444L37.9681 26.8719L63.2636 61.6655H45.8354L28.477 37.7263L28.1142 37.2259L27.7007 37.6853L6.11241 61.6655H2.02225ZM17.5746 4.39406L17.4249 4.18807H17.1702H9.18677H8.2066L8.78198 4.98158L47.4556 58.3169L47.6054 58.5234H47.8604H55.9442H56.9258L56.3486 57.7293L17.5746 4.39406Z",
    fill: "#00EE4E",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXAirdrop);
export default __webpack_public_path__ + "static/media/x-airdrop.37ad70ff79958dff2bdaa129c4e0ac4d.svg";
export { ForwardRef as ReactComponent };